import { resolvePath, useLocation } from 'react-router-dom';
import { Path, To } from 'history';

export const usePreserveQuery = (): ((to: To) => Path) => {
    const location = useLocation();
    return (to: To): Path => {
        let path = resolvePath(to);
        if (location.pathname == path.pathname) {
            path = location;
        }
        return path;
    };
};
